export default "__VITE_ASSET__DJFyklEL__"